/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Cad3Inputs */

const he_currency_cad3 = /** @type {(inputs: Currency_Cad3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAD - Canadian Dollar`)
};

const en_currency_cad3 = /** @type {(inputs: Currency_Cad3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAD - Canadian Dollar`)
};

/**
* | output |
* | --- |
* | "CAD - Canadian Dollar" |
*
* @param {Currency_Cad3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_cad3 = /** @type {((inputs?: Currency_Cad3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Cad3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_cad3(inputs)
	return en_currency_cad3(inputs)
});
export { currency_cad3 as "currency_CAD" }